<div class="shift-compliance-container">
	<div
		class="
			d-flex
			flex-column flex-lg-row
			justify-content-between
			align-items-center
		"
	>
		<img
			class="shift-compliance-left"
			src="../assets/img/made-simple.svg"
			alt=""
		/>

		<div class="shift-compliance-right">
			<h2 class="shift-compliance-header">
				Continuous Compliance <br class="d-none d-sm-block" />
				for Financial Institutions <br class="d-none d-sm-block" />
				Made Simple
			</h2>
			<p class="shift-compliance-para mt-4">
				Prepare your organization for the growing
				<br class="d-none d-sm-block" />
				regulatory burden with RegScale. Support your
				<br class="d-none d-sm-block" />
				enterprise with real-time reporting and analytics.
				<br class="d-none d-sm-block" />
				Inefficient mechanisms and manual risk
				<br class="d-none d-sm-block" />
				monitoring results in a lack of consistency and
				<br class="d-none d-sm-block" />
				standardization. Integrate and manage your
				<br class="d-none d-sm-block" />
				compliance with RegScale to save money, reduce
				<br class="d-none d-sm-block" />
				risk, and increase speed.
			</p>
			<a href="https://go.regscale.com/RegScale-Create-Account">
				<button class="mt-4 shift-compliance-btn bg-white py-2 px-4">
					Find Out How
					<i class="ml-2 fas fa-long-arrow-alt-down"></i></button
			></a>
		</div>
	</div>
</div>
